import { GridViewRounded } from "@mui/icons-material";
import React, { useState, useEffect, useRef } from "react";

function TAPForm(props) {
  const [input, setInput] = useState(props.edit ? props.edit.value : "");
  const [id, setId] = useState(0);
  const giveId = () => {
    setId(id + 1)
    return id;
  }
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus();
  });

  const handleChange = (e) => {
    setInput(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    props.onSubmit({
      id: giveId(),
      text: input,
    });
    setInput("");
  };

  return (
    <form onSubmit={handleSubmit} className="todo-form">
      {props.edit ? (
        <>
          <input
            placeholder="Update your item"
            value={input}
            onChange={handleChange}
            name="text"
            ref={inputRef}
            className="todo-input edit"
          />
          <button onClick={handleSubmit} className="todo-button edit">
            Update
          </button>
        </>
      ) : (
        <>
          <input
            placeholder="Add Here"
            value={input}
            onChange={handleChange}
            name="text"
            className="todo-input"
            ref={inputRef}
          />
          <button onClick={handleSubmit} className="todo-button">
            Add TAP To-Do
          </button>
        </>
      )}
    </form>
  );
}

export default TAPForm;